import React from "react";
import { Loader2 } from "lucide-react";
import HppyfxMark from "@/components/HppyfxMark";

const STEPS = [
  "Reading hospital activity...",
  "Mapping revenue leakage...",
  "Calculating efficiency pressure...",
  "Generating C-suite insights...",
  "Rendering executive dashboard...",
];

export default function LoadingSequence({ label = "Preparing your executive view" }) {
  const [step, setStep] = React.useState(0);

  React.useEffect(() => {
    const id = setInterval(() => {
      setStep((s) => Math.min(s + 1, STEPS.length - 1));
    }, 700);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      className="fixed inset-0 z-40 bg-white flex items-center justify-center"
      data-testid="loading-sequence"
    >
      <div className="max-w-md w-full px-8">
        <div className="flex items-center gap-3 mb-10">
          <HppyfxMark variant="default" />
          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-gray-500">
              Hospital Economics Engine
            </div>
          </div>
        </div>

        <div className="text-[10px] uppercase tracking-[0.3em] text-[#5E3BFF] font-bold mb-3">
          / {label}
        </div>

        <h2 className="font-display text-3xl font-black tracking-tighter leading-tight mb-10">
          Building your command center...
        </h2>

        <ol className="space-y-3">
          {STEPS.map((s, i) => {
            const done = i < step;
            const active = i === step;
            return (
              <li
                key={s}
                className={`flex items-center gap-3 py-2 border-l-2 pl-3 transition-colors duration-300 ${
                  done
                    ? "border-[#16A34A]"
                    : active
                    ? "border-[#5E3BFF]"
                    : "border-gray-200"
                }`}
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  {done ? (
                    <span className="block w-2 h-2 bg-[#16A34A]" />
                  ) : active ? (
                    <Loader2 className="w-4 h-4 text-[#5E3BFF] animate-spin" strokeWidth={1.5} />
                  ) : (
                    <span className="block w-2 h-2 bg-gray-300" />
                  )}
                </span>
                <span
                  className={`text-sm ${
                    done ? "text-gray-400 line-through" : active ? "text-gray-900 font-semibold" : "text-gray-400"
                  }`}
                >
                  {s}
                </span>
              </li>
            );
          })}
        </ol>
      </div>
    </div>
  );
}
